import {getAppUrl} from './helper/Url';

const config = {};

config.versao = '01.07.000/009';
config.atualizado = '14/11/2024';
config.urlImgBase = getAppUrl() + 'img/';

export default config;
